<template>
  <div class="g-page p-user-profile">
    <VLoadingSpinner v-if="loading"></VLoadingSpinner>
    <div class="p-user-profile__grid-container">
      <VGrid>
        <div slot="gridItem" type="12" subtype="relative-sticky-column">
          <!-- TODO Avatar section to be introduced soon (Max - 8.12.20) -->
          <!-- <div slot="row">
            <h3>{{ $t('myProfile.avatar') }}</h3>
            <hr />
          </div>
          <VGrid class="p-user-profile__grid-section-margin">
            <div slot="gridItem" type="4">
              <p>{{ $t('myProfile.makeItEasy') }}</p>
              <p>{{ $t('myProfile.avatarSize') }}</p>
            </div>
            <div slot="gridItem" type="4">
              <b>{{ $t('myProfile.currentAvatar') }}</b>
              <VButton type="outline-1">{{ $t('functional.change') }}</VButton>
            </div>
          </VGrid> -->
          <div slot="row">
            <h3>{{ $t('myProfile.yourProfile') }}</h3>
            <hr />
          </div>
          <VGrid class="p-user-profile__grid-section-margin">
            <div slot="gridItem" type="4">
              <i18n path="myProfile.thisInfoCanBeSeen" tag="p">
                <template v-slot:company>
                  <span>{{ $store.getters['company/company'].name }}.</span><!-- need to include full stop here - if added in locales as should be there is a random space between variable and full stop  -->
                </template>
              </i18n>
            </div>
            <div slot="gridItem" type="4">
              <b>{{ $t('myProfile.fullName') }}</b>
              <p>{{ $store.getters['user/user'].name }}</p>
              <b>{{ $t('myProfile.email') }}</b>
              <p>{{ $store.getters['user/user'].email }}</p>
              <VButton
                  type="outline-1"
                  @click="openEditProfileModal"
                  data-ec="my_profile"
                  data-et="edit_profile_button">
                {{ $t('myProfile.editProfile') }}
              </VButton>
            </div>
          </VGrid>
          <div slot="row">
            <h3>{{ $t('myProfile.security') }}</h3>
            <hr />
          </div>

          <template>
            <VGrid class="p-user-profile__grid-section-margin"  data-test="manage-2fa">
              <div slot="gridItem" type="4">
                <h4>{{ $t('myProfile.twoFactorAuthentication') }}</h4>
                <p v-if="! userHasMfa">{{ $t('myProfile.protectYourAccountByAddingAnAdditionalLayerOfSecurityWhenYouLogIn') }}</p>

                <template v-if="userHasMfa" >
                  <UserMfaEnabledVia :type="userMfa.type" />
                  <p data-test="company-enforces-mfa-text" v-if="companyEnforcesMfa">{{ $t('mfa.yourCompanyHasActivated2FaThisCannotBeChanged')}}</p>
                </template>

              </div>
              <div slot="gridItem" type="4" class="align-middle">
                <VButton
                    v-if="userHasMfa"
                    type="outline-1"
                    data-ec="my_profile"
                    data-et="delete_mfa_button"
                    data-test="delete-mfa-button"
                    :disabled="companyEnforcesMfa"
                    @click="handleDeletingMfa"
                >
                  {{ $t('myProfile.disable') }}
                </VButton>
                <VButton
                    v-else
                    type="outline-1"
                    data-ec="my_profile"
                    data-test="setup-mfa-button"
                    data-et="setup_mfa_button"
                    @click="$router.push({ name: 'SetupMFA' })"
                >
                  {{ $t('myProfile.enable') }}
                </VButton>
                <VButton
                    v-if="userHasMfa"
                    class="ml-base"
                    type="outline-1"
                    data-ec="my_profile"
                    data-et="reset_mfa_button"
                    data-test="reset-mfa-button"
                    @click="handleResettingMfa"
                >
                  {{ $t('myProfile.reset') }}
                </VButton>
              </div>
            </VGrid>

            <VGrid class="p-user-profile__grid-section-margin" data-test="create-mfa-recovery-code" v-if="userHasMfa">
              <div slot="gridItem" type="4">
                <h4>{{ $t('myProfile.recoveryCode') }}</h4>
                <p>{{ $t('myProfile.aRecoveryCodeWasProvidedToYouTheFirstTimeYouSetUp2FaGenerateANewOne') }}</p>
              </div>
              <div slot="gridItem" type="4" class="align-middle">
                <VButton
                    type="outline-1"
                    data-ec="my_profile"
                    data-et="open_create_recovery_code_button"
                    data-test="open-create-recovery-code-button"
                    @click="handleCreatingRecoveryCode"
                >
                  {{ $t('myProfile.generateCode') }}
                </VButton>
              </div>
            </VGrid>
          </template>

          <VGrid class="p-user-profile__grid-section-margin">
            <div slot="gridItem" type="4">
              <h4>{{ $t('myProfile.password') }}</h4>
              <p>{{ $t('myProfile.makeSureUpdatePassword') }}</p>
            </div>
            <div slot="gridItem" type="4" class="align-middle">
              <!-- <p>{{ $t('myProfile.passwordLastUpdated') }}</p> // TODO needs to be re-added in the backend (Max - 8.12.20) -->
                <VButton
                    type="outline-1"
                    @click="openEditPasswordModal"
                    data-ec="my_profile"
                    data-et="open_edit_password_modal_button">
                  {{ $t('myProfile.updatePassword') }}
                </VButton>
            </div>
          </VGrid>
          <div slot="row">
            <h3>{{ $t('myProfile.localisation') }}</h3>
            <hr class="" />
          </div>
          <VGrid class="p-user-profile__grid-section-margin">
            <div slot="gridItem" type="4">
              <p>{{ $t('myProfile.availableLanguages') }}</p>
              <i18n path="myProfile.settingAffects" tag="p">
                <template v-slot:company>
                   <span>{{ $store.getters['company/company'].name }}.</span><!-- need to include full stop here - if added in locales as should be there is a random space between variable and full stop  -->
                </template>
              </i18n>
            </div>
            <div slot="gridItem" type="4">
              <p><b>{{ $t('myProfile.language') }}</b></p>
              <ElSelect
                  class="p-user-profile__language-select"
                  v-model="selectedLanguage" placeholder="Language"
                  data-ec="my_profile"
                  data-et="labguage_select">
                <ElOption
                  @click.native="changeLanguage"
                  v-for="language in languages"
                  :key="language.value"
                  :label="language.label"
                  :value="language.value"
                  data-ec="my_profile"
                  :data-et="`language_option_(${language.label})`">
                </ElOption>
              </ElSelect>
            </div>
          </VGrid>
        </div>
      </VGrid>
    </div>
    <UpdateProfileModal :user="user" :show="showYourProfileModal" @close="showYourProfileModal = false;" />
    <UpdatePasswordModal :show="showYourPasswordModal" @close="showYourPasswordModal = false;" />
    <TWModal
      :title="$t('mfa.yourNewRecoveryCode')"
      :show="showRecoveryCodeModal"
      :loading="loading"
      @close="handleClose">
      <template v-slot:content>
        <p>{{ $t('mfa.saveYourNewRecoveryCodeAndStoreItSomewhereSafe')}}</p>
        <RecoveryCode :code="recoveryCode" />
      </template>
    </TWModal>
  </div>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import i18n from '@/locales';
import { languages } from '@/utils/locale';
import UpdateProfileModal from '@/views/modals/profile/updateProfileModal.vue';
import UpdatePasswordModal from '@/views/modals/profile/updatePasswordModal.vue';
import { mapActions, mapGetters } from 'vuex';
import UserMfaEnabledVia from '@/components/UserMfaEnabledVia.vue';
import TWModal from '@/components/tailwind/Modal.vue';
import { logAmplitudeEvent } from '@/utils/analytics';
import RecoveryCode from '@/components/tailwind/authentication/RecoveryCode.vue';

export default {
  name: 'UserProfile',
  inject: {
    $validator: '$validator',
  },
  components: {
    UserMfaEnabledVia,
    VButton,
    VLoadingSpinner,
    VGrid,
    UpdateProfileModal,
    UpdatePasswordModal,
    TWModal,
    RecoveryCode,
  },
  data() {
    return {
      loading: true,
      showYourProfileModal: false,
      showYourPasswordModal: false,
      languages,
      user: undefined,
      selectedLanguage: undefined,
      showResetMfaModal: false,
      recoveryCode: null,
      showRecoveryCodeModal: false,
    };
  },
  created() {
    this.$store.dispatch('user/GET', { id: this.$store.getters['user/user'].id }).then(() => {
      this.user = JSON.parse(JSON.stringify(this.$store.getters['user/user'])); // Copy object in
      this.selectedLanguage = this.user.language;
      this.loading = false;
    });

    this.getCompanyMfa();
    this.getUserMfa();
  },
  computed: {
    ...mapGetters({
      featureEnabled: 'featureFlags/featureEnabled',
      userMfa: 'userMfa/userMfa',
      companyMfa: 'company/companyMFA',
    }),
    // Programmatically enable validation of Password if one is set.
    hasPassword() {
      return !!this.password;
    },
    userHasMfa() {
      return this.userMfa?.verified;
    },
    companyEnforcesMfa() {
      return this.companyMfa.mfa_enabled;
    },
  },
  methods: {
    ...mapActions({
      getUserMfa: 'userMfa/GET',
      getCompanyMfa: 'company/GET_COMPANY_MFA',
      deleteUserMfa: 'userMfa/DELETE',
      createRecoveryCode: 'userMfa/CREATE_RECOVERY_CODE',
    }),
    openEditProfileModal() {
      this.showYourProfileModal = true;
    },
    openEditPasswordModal() {
      this.showYourPasswordModal = true;
    },
    changeLanguage() {
      if (this.selectedLanguage && (this.selectedLanguage !== this.user.language)) {
        this.loading = true;
        this.user.language = this.selectedLanguage;
        this.$store.dispatch('user/UPDATE', this.user).then(() => {
          this.$bus.$emit('renderGlobalMessage', ({ message: i18n.t('myProfile.messageProfileUpdated'), icon: 'check', type: 'success' }));
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    handleDeletingMfa() {
      this.loading = true;
      this.deleteUserMfa().then(() => {
        this.$bus.$emit('renderGlobalMessage', ({ message: i18n.t('myProfile.mfaDeleted'), icon: 'check', type: 'success' }));
        logAmplitudeEvent('delete_two-factor_authentication--delete-success');
      }).catch(() => {
        this.errorMessage = true;
        logAmplitudeEvent('delete_two-factor_authentication--delete-failed');
      }).finally(() => {
        this.loading = false;
      });
    },
    handleResettingMfa() {
      this.loading = true;
      this.deleteUserMfa().then(() => {
        this.$bus.$emit('renderGlobalMessage', ({ message: i18n.t('myProfile.mfaReset'), icon: 'check', type: 'success' }));
        logAmplitudeEvent('reset_two-factor_authentication--delete-success');
        this.$router.push({ name: 'SetupMFA' });
      }).catch(() => {
        this.errorMessage = true;
        logAmplitudeEvent('reset_two-factor_authentication--delete-failed');
      }).finally(() => {
        this.loading = false;
      });
    },
    handleCreatingRecoveryCode() {
      this.loading = true;
      this.createRecoveryCode().then((response) => {
        this.recoveryCode = response.data.code ? response.data.code : response.data.data.code;
        this.displaySuccess = true;
        this.showRecoveryCodeModal = true;
        logAmplitudeEvent('open_create_recovery_code_button--recovery_code_creation_successful');
      }).catch(() => {
        this.errorMessage = true;
        logAmplitudeEvent('open_create_recovery_code_button--recovery_code_creation_failed');
      }).finally(() => {
        this.loading = false;
      });
    },
    handleClose() {
      this.showRecoveryCodeModal = false;
      this.recoveryCode = null;
    },
  },
};
</script>

<style scoped>
.p-user-profile__grid-container {
  width:100%;
  height: auto;
  padding: 15px;
  border: 1px solid var(--color-border);
  background: #FFF;
}

.p-user-profile__language-select {
  width: 100%;
}

.p-user-profile__grid-section-margin {
  margin-bottom: var(--spacing-large);
  column-gap: var(--spacing-large);
}

.align-middle {
  display: flex;
  align-items: center;
}

.check-label {
  display: inline-block !important;
  vertical-align: super;
  line-height: 28px;
}

hr {
  margin-bottom: 15px;
}
</style>
